import { S3Upload } from '../../api/types'

export function useS3Upload() {
  return async function (data: S3Upload, file: File | Blob) {
    return fetch(data.url, {
      body: file,
      method: 'PUT',
    })
  }
}
